module.exports = __webpack_public_path__ + "img/theraflu_flu_relief_max_strength_daytime_and_nighttime_flu_medicine_bundle_caplets.1cd6bc5d.jpg";